import React from "react";
import { Input as AntdInput } from "antd";
import RCInputNumber from "rc-input-number";
import cx from "classnames";

import "./index.scss";

export const Input = (props) => {
  const { className } = props;
  return (
    <AntdInput
      {...props}
      ref={props.tempRef}
      className={`inputPrimary ${className || ""}`}
    >
      {props.children}
    </AntdInput>
  );
};

export const Password = (props) => {
  return (
    <AntdInput.Password className="inputPrimaryPassword" {...props}>
      {props.children}
    </AntdInput.Password>
  );
};

export const TextArea = (props) => {
  const { className, ...rest } = props;
  return (
    <AntdInput.TextArea
      className={`textarea ${className}`}
      rows={3}
      style={{ resize: "none" }}
      ref={props.tempRef}
      {...rest}
    >
      {props.children}
    </AntdInput.TextArea>
  );
};

export const InputNumber = ({ className = "", tempRef, ...rest }) => {
  const escKeys = ["Enter", ".", "-"];
  const handleKeyPress = (event) => {
    if (!(/[0-9]/.test(event.key) || escKeys.includes(event.key))) {
      event.preventDefault();
    }
  };
  return (
    <RCInputNumber
      {...rest}
      ref={tempRef}
      className={cx(className, "ds-input-number")}
      onKeyPress={handleKeyPress}
      wheel={false}
    />
  );
};
